import { useRouter } from 'next/router';
import { canUserCustomAttributeBeEditedInSettings } from 'shared-helpers/customAttributes';
import { useReduxState } from 'hooks';
import { useApiData } from 'lib/api';
import { LoadingIndicator } from 'components/common';
import { Box, BoxBackLink } from 'components/common/box';
import { PageEmptyIndicator } from 'components/page';
import { UserAttributesAttributeInfo } from '.';

import type { GetUserCustomAttributesRes } from 'shared-types/responses';

const UserAttributesAttribute = () => {
  const { messages, user } = useReduxState();

  const router = useRouter();

  const attributeId = Number(router.query.attributeId);

  const { data, loading, updateData } = useApiData<GetUserCustomAttributesRes>({
    url: `/admin/user-custom-attributes`,
    onlyIf: Boolean(attributeId)
  });

  const userCustomAttributes = data?.userCustomAttributes || [];

  const attribute = userCustomAttributes?.find(
    (userCustomAttribute) => userCustomAttribute.id === attributeId
  );

  const availableAttributes = {};
  userCustomAttributes
    .filter(
      (availableAttribute) =>
        !attribute || availableAttribute.id !== attribute.id
    )
    .forEach((availableAttribute) => {
      availableAttributes[availableAttribute.key] = availableAttribute;
    });

  return (
    <div className="attribute">
      {loading ? (
        <LoadingIndicator />
      ) : !attribute ? (
        <PageEmptyIndicator icon="tag" title={messages.errorNotFound} />
      ) : (
        <Box
          headerContent={
            <BoxBackLink
              as="/admin/settings/user-attributes"
              href="/admin/settings/user-attributes"
              text={messages.commonAllAttributes}
            />
          }
          padding={20}
        >
          <UserAttributesAttributeInfo
            attribute={attribute}
            isDisabled={
              !user?.roles.includes('vuoadmin') &&
              !canUserCustomAttributeBeEditedInSettings(user, attribute)
            }
            isLimited={!user?.roles.includes('vuoadmin')}
            updateData={updateData}
            userCustomAttributes={userCustomAttributes}
          />
        </Box>
      )}
    </div>
  );
};

export default UserAttributesAttribute;
